export default "__VITE_ASSET__BlVLv9X3__"